import { Http } from './http';
import { ErrorWrapper } from './util';
import * as Fingerprint2 from 'fingerprintjs2';
import $axios from 'axios';
import $store from '../store';
import $router from '../router/index';
import Vue from 'vue';

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin ({ username, password, rememberme }) {
    const fingerprint = await _getFingerprint();
    if (!rememberme) rememberme = false;
    Vue.$log.info('Making log in');

    return new Promise((resolve, reject) => {
      $axios.post(`${process.env.VUE_APP_API_URL}/auth/login`, { username, password, fingerprint, rememberme })
        .then(response => {
           $store.dispatch('AUTH_ON_LOGIN', {...response.data.data, rememberme: rememberme});
           return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    });
  }

  static async makeSignup( {username, password, name}) {
    return new Promise((resolve, reject) => {
      $axios.post(`${process.env.VUE_APP_API_URL}/auth/signup`, { username, password, name })
        .then(response => {
           return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    });
  }

  static async makeRestore( token, password ) {
    const fingerprint = await _getFingerprint();
    return new Promise((resolve, reject) => {
      $axios.post(`${process.env.VUE_APP_API_URL}/auth/restore-password`, { token, password, fingerprint })
        .then(response => {
           $store.dispatch('AUTH_ON_LOGIN', {...response.data.data, rememberme: false});
           return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    });
  }

  static async makeSocial( profile ) {
    const fingerprint = await _getFingerprint();
    return new Promise((resolve, reject) => {
      $axios.post(`${process.env.VUE_APP_API_URL}/auth/social`, {
        accessToken: profile.access_token,
        fingerprint: fingerprint
      })
          .then(response => {
            $store.dispatch('AUTH_ON_LOGIN', {...response.data.data, rememberme: false});
            return resolve(response.data.data);
          })
          .catch(error => reject(new ErrorWrapper(error)));
    });
  }

  static async makeConfirm(token) {
    const fingerprint = await _getFingerprint();
    return new Promise((resolve, reject) => {
      new Http().post('auth/confirm', {token, fingerprint})
        .then(response => {
          $store.dispatch('AUTH_ON_LOGIN', {...response.data.data, rememberme: false});
          return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    })
  }

  static async makeReset(username) {
    return new Promise((resolve, reject) => {
      new Http().post('auth/reset-password', {username})
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    })
  }

  static makeLogout () {
    Vue.$log.info('Making log out');
    return new Promise((resolve, reject) => {
      new Http({ auth: true }).post('auth/logout')
        .then(response => {
           $store.dispatch('AUTH_CLEAR');
           $store.dispatch('user/CLEAR');
           $router.push({ name: 'login' });
          return resolve(response.data.data);
        })
        .catch(error => reject(new ErrorWrapper(error)));
    })
  }

  static async refreshTokens () {
    const fingerprint = await _getFingerprint();
    Vue.$log.info('Making tokens refresh');
    return new Promise((resolve) => {
      $axios.post(`${process.env.VUE_APP_API_URL}/auth/token`, {
        refreshToken: this.getRefreshToken(),
        fingerprint
      }).then(response => {
        Vue.$log.debug('Response: ', response);
        $store.dispatch('AUTH_ON_LOGIN', {...response.data.data, rememberme: localStorage.getItem('refreshToken') !== null});
        Vue.$log.info('Token is successfully refreshed');
        return resolve(response.data.data);
      }).catch(() => {
        Vue.$log.info('Token refreshing failed');
        $store.dispatch('AUTH_CLEAR');
        $store.dispatch('user/CLEAR');
        return $router.push({name: 'login'});
      });
    });
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static isAccessTokenExpired () {
    return $store.getters.isExpired();
  }

  static getRefreshToken () {
    return $store.getters.getRefreshToken;
  }

  static getBearer () {
    return $store.getters.bearer;
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _getFingerprint () {
  return new Promise((resolve, reject) => {
    async function getHash () {
      const options = {
        excludes: {
          plugins: true,
          localStorage: true,
          adBlock: true,
          screenResolution: true,
          availableScreenResolution: true,
          enumerateDevices: true,
          pixelRatio: true,
          doNotTrack: true
        }
      };

      try {
        const components = await Fingerprint2.getPromise(options)
        const values = components.map(component => component.value)
        return String(Fingerprint2.x64hash128(values.join(''), 31))
      } catch (e) {
        reject(e)
      }
    }

    if (window.requestIdleCallback) {
      requestIdleCallback(async () => resolve(await getHash()))
    } else {
      setTimeout(async () => resolve(await getHash()), 500)
    }
  })
}
